import { TrainingsContentBlockInput } from 'generated/resources/graphql'

import { Block } from 'modules/trainings/lib/content/Block'

import { InvalidBlockDataError, UnregisteredMapperError } from './errors'
import { GQLContentBlock } from './types'

export interface BlockMapper<TBlock extends Block> {
  readonly graphqlTypename: string
  readonly blockConstructor: typeof Block
  fromGraphQL(gqlBlock: GQLContentBlock): TBlock
  toGraphQL(block: TBlock): TrainingsContentBlockInput
}

export class BlockMapperRegistry {
  private mappersByGraphQLType: ReadonlyMap<string, BlockMapper<Block>>
  private mappers: ReadonlyArray<BlockMapper<Block>>

  constructor(mappers: Array<BlockMapper<Block>> = []) {
    this.mappers = mappers
    this.mappersByGraphQLType = new Map(mappers.map((mapper) => [mapper.graphqlTypename, mapper]))
  }

  fromGraphQL(gqlBlock: GQLContentBlock): Block {
    const typename = gqlBlock.contentable?.__typename

    if (!typename) {
      throw new InvalidBlockDataError('TrainingsContentBlock', '__typename', gqlBlock)
    }

    const mapper = this.mappersByGraphQLType.get(typename)

    if (!mapper) {
      const registeredTypes = Array.from(this.mappersByGraphQLType.keys())
      throw new UnregisteredMapperError(typename, registeredTypes)
    }

    return mapper.fromGraphQL(gqlBlock)
  }

  toGraphQL(block: Block): TrainingsContentBlockInput {
    const mapper = this.mappers.find((m) => block instanceof m.blockConstructor)

    if (!mapper) {
      const registeredTypes = this.mappers.map((m) => m.blockConstructor.name)
      throw new UnregisteredMapperError(block.constructor.name, registeredTypes)
    }

    return mapper.toGraphQL(block)
  }
}
